var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8332 11.0046C21.8332 16.9726 16.9707 21.8327 10.9998 21.8327C5.02896 21.8327 0.166504 16.9726 0.166504 11.0046C0.166504 5.02612 5.02896 0.166016 10.9998 0.166016C16.9707 0.166016 21.8332 5.02612 21.8332 11.0046Z",
    fill: "url(#paint0_linear_4807_14925)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 11.0046C15.3333 11.2784 15.2472 11.5533 15.0748 11.7733C15.0425 11.8165 14.8917 11.9945 14.7732 12.1103L14.7086 12.1735C13.8037 13.1328 11.5524 14.5755 10.4106 15.0378C10.4106 15.0484 9.73201 15.3232 9.40885 15.3327H9.36577C8.87026 15.3327 8.40708 15.0599 8.1701 14.6177C8.04084 14.3744 7.92235 13.6689 7.91158 13.6594C7.81463 13.0265 7.75 12.0577 7.75 10.9941C7.75 9.8789 7.81463 8.86691 7.93312 8.2456C7.93312 8.23507 8.05161 7.66642 8.12701 7.47687C8.2455 7.20413 8.46094 6.9714 8.73023 6.82397C8.94567 6.71972 9.17187 6.66602 9.40885 6.66602C9.65661 6.6776 10.1198 6.8345 10.3029 6.90822C11.5094 7.37156 13.8145 8.88797 14.6978 9.81466C14.8486 9.96209 15.0102 10.1422 15.0533 10.1832C15.2364 10.4149 15.3333 10.6992 15.3333 11.0046Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4807_14925",
    x1: 20.1405,
    y1: 18.4473,
    x2: 2.5363,
    y2: 3.21289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F67F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.042a48e15b77ac9b990fce366f0e0433.svg";
export { ForwardRef as ReactComponent };